import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'

const useGtmLoginInfo = () => {
    const auth = useSelector((state) => state?.services?.auth)
    const user = useSelector((state) => state?.services?.user)
    const location = useLocation()

    useEffect(() => {
        const accountid = user?.accountid
        dataLayer.push({
            user: {
                type: auth?.isAuthorized ? 'logged in' : 'not logged in',
                id: auth?.isAuthorized ? accountid : 'not logged in',
            },
            _clear: true,
        })
    }, [location.pathname])
}

export default useGtmLoginInfo
